import React, { useEffect, useState } from 'react';

// bootstrap
import { Image } from 'react-bootstrap';

// custom components
import { CartCard } from '_components/molecules';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserSavedTransaction } from 'redux/slices/marketplace/user-transaction';
import { setDeliveryMethod, selectDeliveryMethod, selectTableNumber, selectPin } from 'redux/slices/marketplace/user-marketplace';

// styles
import { Spacing, Colors } from '_styles';

// lottie
import Lottie from "lottie-react";
import orderSuccessAnimation from '../../../../../assets/animations/order-successful.json';
import preparingOrderAnimation from '../../../../../assets/animations/order-preparing.json';
import foodDeliveryAnimation from '../../../../../assets/animations/food-delivery.json'

// images
import robotImage from '_assets/images/marketplace/robot.png'

// firebase
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '_utils/marketplace-firebase';

const OrderStatus = ({ setTotalPrice }) => {

    //#region states
    // redux
    const dispatch = useDispatch();
    const userTransaction = useSelector(selectUserSavedTransaction);
    const deliveryMethod = useSelector(selectDeliveryMethod);
    const tableNumber = useSelector(selectTableNumber);
    const pin = useSelector(selectPin)

    // local states
    const [orderStatus, setOrderStatus] = useState('pending');
    const [productList, setProductList] = useState([]);
    const [lastUpdated, setLastUpdated] = useState(false);
    //#endregion

    //#region useEffects
    useEffect(() => {
        dispatch(setDeliveryMethod('robot-order'));
    }, []);

    useEffect(() => {
        let products = userTransaction?.transactionData?.productList || [];
        setProductList(products);
    }, [userTransaction]);

    useEffect(() => {
        if (productList && productList.length > 0) {
            const total = productList.reduce((sum, item) => {
                return sum + item.price * item.quantity;
            }, 0);
            setTotalPrice(total.toFixed(2));
        }
    }, [productList, setTotalPrice]);

    useEffect(() => {

        // query snapshot the firestore order
        // take the id of the order and create query snapshot to list to different changes of the status

        const orderId = userTransaction?.transactionData?.paymentIntentId;

        // check url 
        let url = window.location.href;
        let dbName = 'website-transactions';
        /*if(url.includes('localhost')){
            dbName = 'website-transactions-local';
        }*/

        const ref = doc(firestore, dbName, orderId);
        const unsubscribe = onSnapshot(
            ref,
            (docSnap) => {
                if (docSnap.exists()) {
                    const data = docSnap.data();

                    console.log('data', data);

                    setOrderStatus(data?.currentStatus);

                    // use the order history to find the timestamp
                    if(data?.orderHistory && data?.orderHistory.length > 0) {
                        const lastUpdate = data?.orderHistory[data?.orderHistory?.length - 1];
                        const timestamp = lastUpdate?.time || lastUpdate?.timestamp;
                        if (timestamp) {
                            const formattedDate = new Date(timestamp).toLocaleTimeString('en-GB', {
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                            });
                            setLastUpdated(formattedDate);
                        }
                    }

                } else {
                    console.warn("Document does not exist:", orderId);
                }
            },
            (error) => {
                console.error("Firestore listener error:", error);
            }
        );

        return () => {
            unsubscribe();
        };
    }, [userTransaction]);

    //#endregion

    const renderPinBoxes = () => {
        return String(pin).split('').map((digit, index) => (
            <div key={index} style={styles.pinBox}>
                <p style={styles.pinDigit}>{digit}</p>
            </div>
        ));
    };

    const Hr = () => {
        return (
            <div style={{ width: '90%', alignSelf:'left', height: 1, backgroundColor: 'lightgrey', opacity:0.8, marginLeft:Spacing.SCALE_12 }} />
        )
    }

    return (
        <>

            <div style={{ marginLeft:Spacing.SCALE_12, marginTop:Spacing.SCALE_12, display:'flex', justifyContent:'space-between', marginRight:Spacing.SCALE_22 }}>
                <p style={styles.label}>Order Status</p>
                {lastUpdated && <p style={styles.timestamp}>Last updated: {lastUpdated}</p> }
            </div>

            <Hr />

            {/* pending order */}
            { orderStatus === 'pending' ?
            <div style={styles.messageContainer}>
                <Lottie 
                    animationData={orderSuccessAnimation} 
                    loop={false} 
                    style={{ width: Spacing.SCALE_150, height: Spacing.SCALE_150, marginBottom: Spacing.SCALE_12 }}
                    autoplay={true}
                />
                <p style={styles.title}>Order Recieved!</p>
                <p style={styles.orderWarningMessage}>Keep this page open to see updates to your order status</p>
            </div>
            
            // in-progress order 
            : orderStatus === 'in-progress' ?
            <div style={{...styles.messageContainer, marginTop: Spacing.SCALE_12 }}>
                <p style={styles.title}>Preparing your order</p>
                <p style={styles.orderMessage}>Your order has been received and is now being confirmed</p>
                <Lottie 
                    animationData={preparingOrderAnimation} 
                    loop={false} 
                    style={{ width: Spacing.SCALE_150, height: Spacing.SCALE_150, marginBottom: Spacing.SCALE_12 }}
                    autoplay={true}
                />
            </div>

            // robot on the way 
            : orderStatus === 'completed' ?
            <div style={styles.messageContainer}>
                <div style={{ width: Spacing.SCALE_150, height: 'auto', marginBottom: Spacing.SCALE_12 }}>
                    <Image
                        src={robotImage}
                        height={'100%'}
                        width={'100%'}
                    />
                </div>
                <p style={styles.title}>Our robot server is on the way!</p>
                <p style={styles.orderMessage}>Enter the following pin code to open the robot cabin and access your order:</p>

                <div style={styles.pinContainer}>
                    {renderPinBoxes()}
                </div>
            </div>
            : null }

            <Hr />

            {/* Order Summary */}
            <div style={styles.cardsContainer}>
                <p style={styles.label}>Your items</p>

                {productList.map((item, index) => (
                    <CartCard key={index} item={item} index={index} />
                ))}
            </div>
        </>
    );
};

export default OrderStatus;

const styles = {
    messageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: Spacing.SCALE_12
        //borderStyle:'solid', borderWidth:1 
    },
    orderMessage: {
        fontSize: 18,
        textAlign: 'center',
        padding: `0 ${Spacing.SCALE_20}px`,
        opacity: 0.8
    },
    orderWarningMessage: {
        fontSize: 16,
        fontWeight:'bold',
        textAlign: 'center',
        //padding: `0 ${Spacing.SCALE_20}px`,
        opacity: 0.8
    },
    pinContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: Spacing.SCALE_10,
        gap: Spacing.SCALE_8,
        marginBottom: Spacing.SCALE_16,
    },
    pinBox: {
        border: `1px solid ${Colors.PRM_LIGHT_BLUE}`,
        borderRadius: 6,
        padding: '8px 14px',
        backgroundColor: '#fff',
        boxShadow: `0 2px 6px ${Colors.PRM_LIGHT_BLUE}`,
    },
    pinDigit: {
        fontSize: 24,
        fontWeight: 700,
        margin: 0,
    },
    cardsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: Spacing.SCALE_8,
        padding: `0 ${Spacing.SCALE_20}px ${Spacing.SCALE_20}px`,
        maxHeight: Spacing.SCALE_400,
        overflowY: 'auto',
        marginTop: Spacing.SCALE_12
    },
    title: {
        fontWeight: 'bold',
        fontSize: 22,
        color: Colors.PRM_LIGHT_BLUE,
        marginBottom: Spacing.SCALE_12,
    },
    label: {
        fontSize: 16,
        fontWeight: 600,
        color: '#333',
    },
    timestamp: {
        fontSize: 14,
        fontWeight: 400,
        color: 'grey',
        opacity:0.8
    },
};
